
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 5.33333C2 3.08333 6.33333 2 10.3333 2C14.3333 2 18.6667 3.08333 18.6667 5.33333C18.6667 7.58333 14.3333 8.66667 10.3333 8.66667C6.33333 8.66667 2 7.58333 2 5.33333ZM10.3333 10.3333C7.16667 10.3333 3.91667 9.74998 2 8.33331V12C2 14.25 6.33333 15.3333 10.3333 15.3333C10.6803 15.3333 11.0297 15.3252 11.3786 15.3088C12.2778 12.797 14.679 11 17.5 11C17.8983 11 18.2882 11.0358 18.6667 11.1044V8.33331C16.75 9.74998 13.5 10.3333 10.3333 10.3333ZM10.3333 17C10.5618 17 10.7908 16.997 11.0197 16.9908C11.0066 17.1588 11 17.3286 11 17.5C11 19.1845 11.6408 20.7194 12.692 21.8742C11.9164 21.9583 11.1185 22 10.3333 22C6.33333 22 2 20.9167 2 18.6667V15C3.91667 16.4167 7.16667 17 10.3333 17ZM18.5303 13.4697L18 12.9393L17.4697 13.4697L15.4697 15.4697L16.5303 16.5303L17.25 15.8107V19H18.75V15.8107L19.4697 16.5303L20.5303 15.4697L18.5303 13.4697ZM13.25 17V21V21.75H14H22H22.75V21V17H21.25V20.25H14.75V17H13.25Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowexportdataFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
